export default function OrganizationSubscriptionDetails({ label, value }) {
  return (
    <li className="flex justify-between gap-4 py-3 align-middle md:grid md:grid-cols-3">
      <div className="text-left text-primary-dark md:w-full">{label}</div>
      <div className="px-4 text-primary-dark/60">{!value ? '-' : value}</div>
    </li>
  );
}
